var parent = require('../../es/instance/reduce');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/reduce.js
// module id = 1116
// module chunks = 0